// extracted by mini-css-extract-plugin
export default {"inputHeader":"createCustomPlanModal_inputHeader__khdSm","firstHeader":"createCustomPlanModal_firstHeader__kLTV4","warningButton":"createCustomPlanModal_warningButton__WW8t8"};